
import Vue from "vue";
import { avatars } from "../App.vue";

export default Vue.extend({
  name: "PlayerAvatarContainer",
  props: {
    playerId: Number,
  },
  computed: {
    fill: {
      get(): string {
        return avatars[this.playerId].fill;
      },
    },
  },
});
